// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  addPromotionQuery,
  fetchPromotionByIdQuery,
  fetchPromotionTableQuery,
  removePromotionQuery,
  updatePromotionQuery,
} from "../../api/promotionApi";

export const getPromotion = createAsyncThunk(
  "promotion/getPromotion",
  async (
    { page, limit, lan }: { page: number; limit: number; lan: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await fetchPromotionTableQuery(page, limit, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPromotionById = createAsyncThunk(
  "promotion/getPromotionById",
  async (
    { id, lan }: { id: string; lan: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await fetchPromotionByIdQuery(id, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createPromotion = createAsyncThunk(
  "promotion/createPromotion",
  async (
    newPromotion: { name: string; description: string; icon: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await addPromotionQuery(newPromotion);
    } catch (error: any) {
      // // console.log(error,'errrrrr');

      return rejectWithValue(error);
    }
  }
);

export const editPromotion = createAsyncThunk(
  "promotion/editPromotion",
  async (
    {
      id,
      updatedPromotion,
      lan,
    }: {
      id: string;
      updatedPromotion: { name: string; description: string; icon?: string };
      lan: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updatePromotionQuery(id, updatedPromotion, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePromotion = createAsyncThunk(
  "promotion/deletePromotion",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removePromotionQuery(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Other Service Slice

const promotionSlice = createSlice({
  name: "promotion",
  initialState: {
    promotions: [] as any[],
    promotion: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all Other services
      .addCase(
        getPromotion.fulfilled,
        (state, action: PayloadAction<any[]>) => {
          state.status = true;
          state.promotions = action.payload;
        }
      )
      .addCase(getPromotion.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      .addCase(
        getPromotionById.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.promotion = action.payload;
        }
      )
      .addCase(getPromotionById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      .addCase(
        createPromotion.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (Array.isArray(action.payload)) {
            state.promotions.push(action.payload);
            state.status = true;
            state.msg = "Other service created successfully.";
          } else {
            // // // console.log('Other service not an array');
          }
        }
      )

      .addCase(editPromotion.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.promotions)) {
          const index = state.promotions.findIndex(
            (service) => service.id === id
          );
          if (index !== -1) {
            state.promotions[index] = data;
          }
          state.status = true;
          state.msg = "Other service updated successfully.";
        } else {
          // // // console.log('Other service not an array');
        }
      })

      .addCase(
        deletePromotion.fulfilled,
        (state, action: PayloadAction<string>) => {
          if (Array.isArray(state.promotions)) {
            state.promotions = state.promotions.filter(
              (service) => service.id !== action.payload
            );
            state.status = true;
            state.msg = "Other service deleted successfully.";
          } else {
            // // // console.log('Other service not an array');
          }
        }
      );
  },
});

export const { resetStatus } = promotionSlice.actions;
export default promotionSlice.reducer;
